import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import "../App.css";
const Update = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [age, setAge] = useState(0);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const { id } = useParams();
  const navigate  = useNavigate();


  useEffect(() => {
    getSingleData();
  }, []);

  const getSingleData = async () => {
    //take id from url
    const response = await fetch(`https://blogapp1-p9km.onrender.com/${id}`);
    const result = await response.json();
    setName(result.name);
    setEmail(result.email);
    setAge(result.age);
    // console.log(result);
  }

  const handleEdit = async (e) => {
    e.preventDefault();
    const updateUser = { name, email, age };
    // console.log(addUser)
    const response = await fetch(`https://blogapp1-p9km.onrender.com/edit/${id}`, {
      method: 'PATCH',
      body: JSON.stringify(updateUser),
      headers: {
        "Content-type": "application/json"
      }
    });
    const result = await response.json();
    if (!response.ok) {
      setError(result.error)
      setSuccess("");
    }
    if (response.ok) {
      setSuccess(`${name} Updated Successfully`);
      setError("");
      setName("");
      setEmail("");
      setAge(0);
      document.getElementsByClassName('updatedata')[0].style.display="none";
      setTimeout(() => {
        navigate('/all');
      }, 3000);
    }
  }
  return (
    <div className='container'>
      <center>
        <h1>Update</h1>
        <hr />
      {error && <div className="alert alert-danger text-center" role="alert">{error}</div>}
      {success && <div className="alert alert-success text-center" role="alert">{success}</div>}
        <div className="updatedata">
        <form className='my-5' onSubmit={handleEdit}>
          <div className="mb-3 col-6">
            <label htmlFor="exampleInputEmail1" className="form-label">Name</label>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className="form-control" aria-describedby="emailHelp" />
          </div>
          <div className="mb-3 col-6">
            <label htmlFor="exampleInputPassword1" className="form-label">Email</label>
            <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} className="form-control" />
          </div>
          <div className="mb-3 col-3">
            <label htmlFor="exampleInputPassword1" className="form-label">Age</label>
            <input type="number" value={age} onChange={(e) => setAge(e.target.value)} className="form-control" />
          </div>
          <button type="submit" className="btn btn-success">Submit</button>
        </form>
        </div>
      </center>
    </div>
  )
}
export default Update
